import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Stack } from '@startuptools/ui/Stack';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useAuthorizationSelectDialogSuspenseQuery } from './AuthorizationSelectDialog.graphql';
import { Table } from '@startuptools/ui/Table';
import { Trans, useLingui } from '@lingui/react';
import { DateFormat } from '@startuptools/ui/DateFormat';
import DialogContent from '@mui/joy/DialogContent';

export const AuthorizationSelectDialog = ({
  onClose,
  onSelected,
}: {
  onClose: () => void;
  onSelected: (snrAuthId: string) => Promise<unknown>;
}) => {
  const companyId = useCompanyId();
  const { i18n } = useLingui();
  const {
    data: { snrAuthorizations },
  } = useAuthorizationSelectDialogSuspenseQuery({ variables: { companyId } });

  return (
    <Modal open onClose={onClose}>
      <ModalDialog sx={{ minWidth: 600 }}>
        <ModalClose />
        <DialogContent sx={{ mt: 3 }}>
          <Stack gap={3}>
            <Table hoverRow sx={{ tableLayout: 'auto' }}>
              <thead>
                <tr>
                  <th>
                    <Trans id="Registration Date" />
                  </th>
                  <th>
                    <Trans id="Kinds" />
                  </th>
                  <th>
                    <Trans id="Valid Thru" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {snrAuthorizations.map(a => (
                  <tr key={a.id} onClick={() => onSelected(a.id).then(() => onClose())} style={{ cursor: 'pointer' }}>
                    <td>
                      <DateFormat locale={i18n.locale}>{a.registrationDate}</DateFormat>
                    </td>
                    <td>{a.auths.map(inp => inp.kind).join(', ')}</td>
                    <td>{a.auths[0]?.before_year || a.auths[0]?.before}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Stack>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};
